<template>
  <div class="actions-col d-flex align-center ga-4 justify-center">
    <button @click="goToPreview(item.id, item)">
      <img :src="eyeIcon" alt="eyeIcon" />
    </button>
    <button @click="store.openMeetingDialog(item.id, item)">
      <img :src="meetingIcon" alt="meetingIcon" />
    </button>
    <button @click="store.openCallDialog(item.id, item)">
      <img :src="callIcon" alt="callIcon" />
    </button>

    <v-dialog v-model="store.callDialog" width="700" class="add-call-dialog">
      <v-card class="">
        <div
          class="card-header mb-3 px-4 py-2 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center ga-2">
            <span>
              <img :src="call_icon" alt="" />
            </span>
            <p>Schedule A Call</p>
          </div>
          <button @click="store.callDialog = false">
            <v-icon icon="mdi-close" size="18" color="#237276" />
          </button>
        </div>
        <div class="card-body px-4 py-2">
          <v-container class="pa-0 ma-0">
            <v-row no-gutters>
              <v-col cols="6">
                <label for="call_for">Call For</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="store.data_call.call_for"
                />
              </v-col>
              <v-col cols="6">
                <label for="number">Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="store.data_call.number"
                />
              </v-col>
              <v-col cols="6" class="date-picker">
                <label for="status">Call Start Date & Time </label>
                <VueDatePicker
                  class=""
                  style="width: 95%"
                  v-model="store.data_call.from"
                >
                </VueDatePicker>
              </v-col>
              <!-- <v-col cols="6">
                <label for="status">Call End Date & Time </label>

                <VueDatePicker
                  style="width: 95%"
                  v-model="store.data_call.to"
                ></VueDatePicker>
              </v-col> -->
              <v-col cols="6">
                <label for="status">Status </label>

                <v-select
                  v-model="store.data_call.status"
                  :items="store.call_statuses"
                  variant="outlined"
                  hide-details
                  placeholder="Select Status"
                  item-title="title"
                  item-value="value"
                  class="custom-v-select"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <label for="status">Notes </label>
                <textarea
                  v-model="store.data_call.content"
                  variant="outlined"
                  hide-details
                  placeholder="Enter Content"
                  rows="5"
                ></textarea>
              </v-col>
              <v-col
                cols="12"
                class="d-flex align-center justify-end ga-2 pr-3"
              >
                <button class="cancel-btn" @click="store.callDialog = false">
                  Cancel
                </button>
                <button
                  class="save-btn"
                  @click="store.createCall(store.call_id)"
                >
                  Save
                </button>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="store.meetingDialog" width="700" class="add-call-dialog">
      <v-card class="">
        <div
          class="card-header mb-3 px-4 py-2 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center ga-2">
            <span>
              <img :src="call_icon" alt="" />
            </span>
            <p>Schedule A Meeting</p>
          </div>
          <button @click="store.meetingDialog = false">
            <v-icon icon="mdi-close" size="18" color="#237276" />
          </button>
        </div>
        <div class="card-body px-4 py-2">
          <v-container class="pa-0 ma-0">
            <v-row no-gutters>
              <v-col cols="6">
                <label for="meeting_for">Meeting For</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="store.data_meeting.meeting_for"
                />
              </v-col>
              <v-col cols="6">
                <label for="number">Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="store.data_meeting.number"
                />
              </v-col>
              <v-col cols="6">
                <label for="meeting_title">Meeting Title</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="store.data_meeting.meeting_title"
                />
              </v-col>
              <v-col cols="6">
                <label for="number">Meeting place</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="store.data_meeting.meeting_place"
                />
              </v-col>
              <v-col cols="6">
                <label for="status">Meeting Start Date & Time </label>
                <VueDatePicker
                  style="width: 95%"
                  v-model="store.data_meeting.from"
                >
                </VueDatePicker>
              </v-col>
              <v-col cols="6">
                <label for="status">Meeting End Date & Time </label>
                <VueDatePicker
                  style="width: 95%"
                  v-model="store.data_meeting.to"
                ></VueDatePicker>
              </v-col>
              <v-col cols="6">
                <label for="status">Attendees </label>

                <v-select
                  @click="store.getAgencies()"
                  hide-details
                  return-object
                  :items="store.arr_agency"
                  variant="outlined"
                  class="custom-v-select"
                  placeholder="Select Agency"
                  v-model="store.selectedAgency"
                  no-details
                  clearable
                >
                  <!-- تخصيص عرض العناصر داخل القائمة -->
                  <template v-slot:item="{ item }">
                    <v-list-item @click="selectedAgency(item)">
                      <div class="d-flex align-center gap-5">
                        <img
                          :src="item.raw.image"
                          alt=""
                          style="
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            object-fit: cover;
                            display: flex;
                          "
                        />
                        <span style="display: flex; margin-left: 10px">{{
                          item.raw.first_name + " " + item.raw.last_name
                        }}</span>
                      </div>
                    </v-list-item>
                  </template>

                  <!-- تخصيص عرض القيمة المختارة -->
                  <template v-slot:selection="{ item }">
                    <div class="d-flex align-center gap-2">
                      <v-chip
                        variant="outlined"
                        closable
                        @click:close="removeAgency(item)"
                      >
                        <img
                          :src="item.raw.image"
                          alt=""
                          style="
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                            object-fit: cover;
                            display: flex;
                          "
                        />
                      </v-chip>
                    </div>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="6">
                <label for="status">Status </label>

                <v-select
                  v-model="store.data_meeting.status"
                  :items="store.call_statuses"
                  variant="outlined"
                  hide-details
                  placeholder="Select Status"
                  item-title="title"
                  item-value="value"
                  class="custom-v-select"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <label for="status">Notes </label>
                <textarea
                  v-model="store.data_meeting.content"
                  variant="outlined"
                  hide-details
                  placeholder="Enter Content"
                  rows="5"
                ></textarea>
              </v-col>
              <v-col
                cols="12"
                class="d-flex align-center justify-end ga-2 pr-3"
              >
                <button class="cancel-btn" @click="store.meetingDialog = false">
                  Cancel
                </button>
                <button class="save-btn" @click="store.createMeeting()">
                  Save
                </button>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import meetingIcon from "@/assets/images/brandify/meeting.svg";
import eyeIcon from "@/assets/images/brandify/Eye.svg";
import callIcon from "@/assets/images/brandify/2call_icon.svg";
import call_icon from "@/assets/images/brandify/call_icon.svg";

import { useLeadsStore } from "@/store/crm/useLeadsStore";
import addIcon from "@/assets/images/brandify/add_icon.svg";
import calender from "@/assets/images/brandify/calender.svg";
import VueDatePicker from "@vuepic/vue-datepicker";

export default {
  name: "ActionsCol",
  props: ["item"],

  components: {
    VueDatePicker,
  },
  data() {
    return {
      eyeIcon,
      meetingIcon,
      callIcon,
      store: useLeadsStore(),
      addIcon,
      call_icon,
      calender,
    };
  },
  methods: {
    goToPreview(id, item) {
      localStorage.setItem("leadId", id);
      this.$router.push(`/leads/preview/${id}`);
      console.log(item);
    },

    selectedAgency(item) {
      if (!Array.isArray(this.store.selectedAgency))
        this.store.selectedAgency = [];
      const exists = this.store.selectedAgency.some(
        (a) => (a.id ?? a.raw?.id) === (item.raw?.id ?? item.id)
      );
      if (!exists) this.store.selectedAgency.push(item.raw ?? item);
      if (!Array.isArray(this.store.data_meeting.agent_id))
        this.store.data_meeting.agent_id = [];
      if (!this.store.data_meeting.agent_id.includes(item.raw.id)) {
        this.store.data_meeting.agent_id.push(item.raw.id);
      }
    },
    unselectAgency(id) {
      this.store.selectedAgency = this.store.selectedAgency.filter(
        (a) => a.id !== id
      );
      this.store.data_meeting.agent_id =
        this.store.data_meeting.agent_id.filter((x) => x !== id);
    },
    removeAgency(item) {
      const id = item?.raw?.id ?? item?.id;

      // شيل من selectedAgency (لو Array)
      if (Array.isArray(this.store.selectedAgency)) {
        this.store.selectedAgency = this.store.selectedAgency.filter(
          (a) => (a.id ?? a.raw?.id) !== id
        );
        if (this.store.selectedAgency.length === 0) {
          // اختياري: لما تفضى خليها [] بدل null لتفادي أخطاء مشابهة
          this.store.selectedAgency = [];
        }
      } else {
        // لو Single لأي سبب
        this.store.selectedAgency = null;
      }

      // شيل من agent_id
      if (!Array.isArray(this.store.data_meeting.agent_id))
        this.store.data_meeting.agent_id = [];
      this.store.data_meeting.agent_id =
        this.store.data_meeting.agent_id.filter((x) => x !== id);
    },
  },
  mounted() {
    // this.store.getAgencies();
  },
  watch: {
    "store.leads": {
      handler() {
        this.store.data_meeting.meeting_for =
          this.item.firstName + " " + this.item.lastName;
        this.store.data_meeting.number = this.item.phoneNumber;
        this.store.data_call.call_for =
          this.item.firstName + " " + this.item.lastName;
        this.store.data_call.number = this.item.phoneNumber;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.date-picker input {
  border: 1px solid #e8e8e8 !important ;
  outline: none !important;
}
.add-call-dialog :deep(.v-overlay__scrim) {
  background: rgba(0, 0, 0, 0.3) !important;
  opacity: 1 !important;
}
</style>
